/* ============================================================================
   Harmony — Réservation démonstration
   ----------------------------------------------------------------------------
   - Structure (sélecteur, formulaires, boutons) rendue dans le Liquid
   - Le JS câble les boutons par [data-action] et bascule les écrans
   - Villes regroupées : une ville = plusieurs dates, chaque date avec son agent
   - Boutons au style du thème (button button--primary dot_active)
   ========================================================================== */

(function () {
	'use strict';

	function initSection(root) {
		if (!root || root.__harmonyRInit) return;
		root.__harmonyRInit = true;

		/* ---- Connexions n8n (en dur) ---- */
		var ENDPOINTS = {
			creneaux: 'https://n8n.octavio.pro/webhook/harmony-creneaux',
			reservation: 'https://n8n.octavio.pro/webhook/harmony-reservation',
			proposition: 'https://n8n.octavio.pro/webhook/harmony-proposition-ville'
		};

		/* ---- Textes (injectés par le Liquid) ---- */
		var CFG = {};
		var cfgEl = root.querySelector('[data-harmony-r-config]');
		if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; } }
		var T = CFG.texts || {};
		function txt(k, f) { return (T[k] != null && T[k] !== '') ? T[k] : f; }

		/* ---- Tracking : Matomo (sendBeacon direct) + Meta Pixel (D1/D2) ---- */
		var MATOMO = { url: 'https://matomo.octavio.pro/matomo.php', siteId: 1 };
		var _trackedOnce = {};

		// Envoie un événement Matomo via sendBeacon (indépendant de window._paq)
		function matomoEvent(action, name, value) {
			try {
				var p = new URLSearchParams({
					idsite: String(MATOMO.siteId),
					rec: '1',
					apiv: '1',
					rand: String(Date.now()) + Math.random().toString(36).slice(2),
					url: window.location.href,
					e_c: 'Harmony Réservation',
					e_a: action
				});
				if (name != null && name !== '') p.set('e_n', String(name));
				if (value != null && value !== '') p.set('e_v', String(value));
				var full = MATOMO.url + '?' + p.toString();
				if (navigator.sendBeacon) { navigator.sendBeacon(full); }
				else { var i = new Image(); i.src = full; }
			} catch (e) {}
		}

		// Événement Meta Pixel (si fbq présent sur la page)
		function metaEvent(name, params) {
			try { if (typeof window.fbq === 'function') window.fbq('track', name, params || {}); } catch (e) {}
		}

		// Étape de funnel : Matomo + (optionnel) dédup one-shot
		function trackEvent(step, props) {
			props = props || {};
			var label = props.ville || '';
			matomoEvent(step, label, props.value);
		}


		/* ---- DOM ---- */
		var selectWrap = root.querySelector('[data-select-wrap]');
		var selectBtn = root.querySelector('[data-select]');
		var selectText = root.querySelector('[data-select-text]');
		var searchInput = root.querySelector('[data-search]');
		var optList = root.querySelector('[data-opt-list]');
		var slotsBox = root.querySelector('[data-slots]');
		var formBox = root.querySelector('[data-form]');
		var proposeBtn = root.querySelector('[data-propose]');
		var proposeForm = root.querySelector('[data-propose-form]');
		var proposeBack = root.querySelector('[data-propose-back]');
		var mainBlocks = root.querySelector('[data-main]');
		var leftCol = root.querySelector('[data-left]');
		var mapBox = root.querySelector('[data-map]');
		var mapShapeTpl = root.querySelector('[data-map-shape]');

		/* ---- Projection carte ---- */
		var MAP = { w: 460, h: 480, lngMin: -5.2, lngMax: 10.8, latMin: 41.0, latMax: 51.6 };
		function project(lat, lng) {
			return {
				x: (lng - MAP.lngMin) / (MAP.lngMax - MAP.lngMin) * MAP.w,
				y: (MAP.latMax - lat) / (MAP.latMax - MAP.latMin) * MAP.h
			};
		}

		/* ---- État ---- */
		var state = { villes: [], selected: null, slotDate: null, slot: null, showAllSlots: false };

		/* ---- Helpers ---- */
		function el(tag, cls, html) {
			var e = document.createElement(tag);
			if (cls) e.className = cls;
			if (html != null) e.innerHTML = html;
			return e;
		}
		function fmtDate(iso) {
			try {
				var d = new Date(iso + 'T00:00:00Z');
				return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
			} catch (e) { return iso; }
		}
		function cityLabel(v) {
			var d = (v.dept && v.dept !== 0 && v.dept !== '0') ? ' (' + v.dept + ')' : '';
			return v.ville + d;
		}
		function pinSvg() {
			return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
				'<path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7z" fill="currentColor"/></svg>';
		}

		/* ---- Sélecteur ---- */
		selectBtn.addEventListener('click', function (e) {
			e.stopPropagation();
			selectWrap.classList.toggle('is-open');
			if (selectWrap.classList.contains('is-open')) {
				searchInput.value = ''; renderOptions(''); searchInput.focus();
			}
		});
		searchInput.addEventListener('input', function () { renderOptions(this.value); });
		searchInput.addEventListener('click', function (e) { e.stopPropagation(); });
		document.addEventListener('click', function () { selectWrap.classList.remove('is-open'); });

		function renderOptions(filter) {
			optList.innerHTML = '';
			var f = (filter || '').toLowerCase().trim();
			var matches = state.villes.filter(function (v) {
				return v.ville.toLowerCase().indexOf(f) !== -1;
			});
			if (!matches.length) {
				optList.appendChild(el('div', 'harmony-r__opt-empty', 'Aucune ville ne correspond.'));
				return;
			}
			matches.forEach(function (v) {
				var o = el('div', 'harmony-r__opt');
				var d = (v.dept && v.dept !== 0 && v.dept !== '0') ? ' (' + v.dept + ')' : '';
				o.innerHTML = pinSvg() +
					'<span><span class="harmony-r__opt-city">' + v.ville + d + '</span></span>';
				if (state.selected && state.selected === v) o.classList.add('is-active');
				o.addEventListener('click', function (e) {
					e.stopPropagation(); selectCity(v); selectWrap.classList.remove('is-open');
				});
				optList.appendChild(o);
			});
		}

		function selectCity(v, opts) {
			state.selected = v; state.slotDate = null; state.slot = null;
			state.showAllSlots = false; // B1 : replier à chaque changement de ville
			selectText.textContent = cityLabel(v);
			if (!(opts && opts.silent)) trackEvent('ville_choisie', { ville: v.ville });
			renderSlots(); updateFormVisibility(); highlightMarkerVille(v);
		}

		/* ---- Créneaux (groupés par date, agent par date) ---- */
		var VISIBLE_DATES = 2; // B1

		function renderSlots() {
			slotsBox.innerHTML = '';
			var v = state.selected;
			if (!v) return;
			var dates = v.dates || [];
			var limit = state.showAllSlots ? dates.length : VISIBLE_DATES;
			var shown = dates.slice(0, limit);

			shown.forEach(function (jour) {
				// B2 — carte de session (photo + date/quartier + phrase/hôte)
				var card = el('div', 'harmony-r__session');

				// Photo (B3) — lazy, ne charge que si présente ; ratio fixe pour éviter le reflow
				if (jour.photo) {
					var media = el('div', 'harmony-r__session-media');
					var img = document.createElement('img');
					img.className = 'harmony-r__session-img';
					img.src = jour.photo;
					img.alt = '';
					img.loading = 'lazy';
					img.decoding = 'async';
					media.appendChild(img);
					card.appendChild(media);
				}

				var info = el('div', 'harmony-r__session-info');
				var em = function (e) { return '<span class="harmony-r__session-emoji">' + e + '</span> '; };

				// Ligne 1 : date avec emoji
				info.appendChild(el('div', 'harmony-r__session-date', em('📅') + fmtDate(jour.date)));

				// Ligne 2 : quartier (ou ville) avec emoji
				var lieu = jour.quartier || v.ville;
				if (lieu) info.appendChild(el('div', 'harmony-r__session-place', em('📍') + lieu));

				// Ligne 3 : agent avec emoji
				if (jour.agent) info.appendChild(el('div', 'harmony-r__session-agent', em('👤') + 'avec ' + jour.agent));

				card.appendChild(info);
				slotsBox.appendChild(card);

				var grid = el('div', 'harmony-r__slot-grid');
				(jour.heures || []).forEach(function (h) {
					var b = el('button', 'harmony-r__slot', h.label);
					b.type = 'button';
					if (state.slotDate === jour && state.slot && state.slot.heure === h.heure) {
						b.classList.add('is-selected');
					}
					b.addEventListener('click', function () {
						state.slotDate = jour; state.slot = h;
						clearSlotsNotice();
						trackEvent('creneau_choisi', { ville: v.ville });
						renderSlots(); updateFormVisibility();
					});
					grid.appendChild(b);
				});
				slotsBox.appendChild(grid);
			});

			// B1 — bouton "Voir plus de créneaux" s'il reste des dates cachées
			if (!state.showAllSlots && dates.length > VISIBLE_DATES) {
				var more = el('button', 'harmony-r__more');
				more.type = 'button';
				var reste = dates.length - VISIBLE_DATES;
				more.textContent = 'Voir plus de créneaux (' + reste + ' autre' + (reste > 1 ? 's' : '') + ' date' + (reste > 1 ? 's' : '') + ')';
				more.addEventListener('click', function () {
					state.showAllSlots = true;
					trackEvent('voir_plus_creneaux', { ville: v.ville });
					renderSlots();
				});
				slotsBox.appendChild(more);
			}
		}

		/* ---- Affichage du formulaire (déjà dans le Liquid) ---- */
		function updateFormVisibility() {
			if (state.selected && state.slotDate && state.slot) {
				formBox.hidden = false;
			} else {
				formBox.hidden = true;
			}
		}

		/* ---- Carte ---- */
		function renderMap() {
			var shape = mapShapeTpl ? mapShapeTpl.innerHTML : '';
			var markers = '';
			state.villes.forEach(function (v, idx) {
				if (!isFinite(v.lat) || !isFinite(v.lng) || (v.lat === 0 && v.lng === 0)) return;
				var p = project(v.lat, v.lng);
				markers += '<g class="harmony-r__marker" data-idx="' + idx + '" transform="translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ')">' +
					'<circle class="harmony-r__marker-pulse" cx="0" cy="0" r="6"/>' +
					'<circle class="harmony-r__marker-dot" cx="0" cy="0" r="6"/>' +
					'<text class="harmony-r__marker-label" x="0" y="-12" text-anchor="middle">' + v.ville + '</text>' +
					'</g>';
			});
			mapBox.innerHTML = '<svg class="harmony-r__map-svg" viewBox="0 0 ' + MAP.w + ' ' + MAP.h +
				'" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Carte des villes de démonstration">' +
				shape + markers + '</svg>';
		}
		function highlightMarkerVille(v) {
			var idx = state.villes.indexOf(v);
			Array.prototype.forEach.call(mapBox.querySelectorAll('.harmony-r__marker'), function (g) {
				g.classList.toggle('is-active', g.getAttribute('data-idx') === String(idx));
			});
		}

		/* ---- Lecture des champs ---- */
		function readFields(attr) {
			var data = {};
			Array.prototype.forEach.call(root.querySelectorAll('[' + attr + ']'), function (i) {
				data[i.getAttribute(attr)] = i.value.trim();
			});
			return data;
		}

		/* ---- Actions (boutons câblés par data-action) ---- */
		var submitBtn = root.querySelector('[data-action="submit-reservation"]');
		if (submitBtn) submitBtn.addEventListener('click', submitReservation);
		var proposeSubmit = root.querySelector('[data-action="submit-proposition"]');
		if (proposeSubmit) proposeSubmit.addEventListener('click', submitProposition);

		/* ---- Échanger avec un expert (popup Cal.com, chargé au clic) ---- */
		var expertBtn = root.querySelector('[data-action="expert"]');
		if (expertBtn) expertBtn.addEventListener('click', function () {
			var url = expertBtn.getAttribute('data-expert-url');
			if (!url) return;
			openCalcom(url, expertBtn);
		});

		function calLinkFromUrl(url) {
			try { return new URL(url).pathname.replace(/^\/+/, ''); }
			catch (e) { return url.replace(/^https?:\/\/[^/]+\//, ''); }
		}

		function openCalcom(url, btn) {
			var calLink = calLinkFromUrl(url);
			var origin, embedSrc;
			try {
				var u = new URL(url);
				origin = u.origin;                       // ex: https://cal.octavio.pro
				embedSrc = u.origin + '/embed/embed.js'; // embed servi par le domaine self-hosted
			} catch (e) {
				origin = 'https://app.cal.com';
				embedSrc = 'https://app.cal.com/embed/embed.js';
			}

			// Feedback visuel bref (le popup s'ouvre via la file d'attente native)
			var prev = btn ? btn.innerHTML : null;
			if (btn) { btn.innerHTML = '<span>Ouverture…</span>'; }
			setTimeout(function () { if (btn && prev) btn.innerHTML = prev; }, 2500);

			// Snippet officiel Cal.com : file d'attente intégrée (les commandes
			// passées avant le chargement complet sont rejouées ensuite)
			(function (C, A, L) {
				var p = function (a, ar) { a.q.push(ar); };
				var d = C.document;
				C.Cal = C.Cal || function () {
					var cal = C.Cal; var ar = arguments;
					if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; }
					if (ar[0] === L) { var api = function () { p(api, arguments); }; var namespace = ar[1]; api.q = api.q || []; typeof namespace === 'string' ? (cal.ns[namespace] = api) && p(api, ar) : p(cal, ar); return; }
					p(cal, ar);
				};
			})(window, embedSrc, 'init');

			// Init + ouverture immédiate (mises en file si le script n'est pas prêt)
			try {
				window.Cal('init', { origin: origin });
				window.Cal('modal', { calLink: calLink });
			} catch (e) {
				window.open(url, '_blank', 'noopener');
			}
		}

		/* ---- Validation des formulaires ---- */
		var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		function showFieldError(input, msg) {
			input.classList.add('harmony-r__input--error');
			var err = root.querySelector('[data-error-for="' + input.id + '"]');
			if (err) { err.textContent = msg; err.hidden = false; }
		}
		function clearFieldError(input) {
			input.classList.remove('harmony-r__input--error');
			var err = root.querySelector('[data-error-for="' + input.id + '"]');
			if (err) { err.hidden = true; err.textContent = ''; }
		}

		function validateForm(scope) {
			var ok = true;
			var firstInvalid = null;
			var fields = scope.querySelectorAll('[data-required]');
			Array.prototype.forEach.call(fields, function (input) {
				clearFieldError(input);
				var v = (input.value || '').trim();
				if (!v) {
					showFieldError(input, 'Ce champ est requis.');
					ok = false; if (!firstInvalid) firstInvalid = input;
					return;
				}
				if (input.getAttribute('data-type') === 'email' && !EMAIL_RE.test(v)) {
					showFieldError(input, 'Adresse e-mail invalide.');
					ok = false; if (!firstInvalid) firstInvalid = input;
				}
			});
			if (firstInvalid) firstInvalid.focus();
			return ok;
		}

		// Message d'erreur global du formulaire (collision, erreur réseau) — inline, pas d'alert
		function showFormError(msg) {
			var box = root.querySelector('[data-form-error]');
			if (!box) {
				box = el('div', 'harmony-r__form-error');
				box.setAttribute('data-form-error', '');
				var fields = root.querySelector('[data-form] .harmony-r__form-fields') || formBox;
				if (fields) fields.insertBefore(box, fields.firstChild);
			}
			box.textContent = msg;
			box.hidden = false;
			if (box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
		function clearFormError() {
			var box = root.querySelector('[data-form-error]');
			if (box) { box.hidden = true; box.textContent = ''; }
		}

		// Message persistant AU-DESSUS de la zone créneaux (survit au rechargement des créneaux)
		function showSlotsNotice(msg) {
			var notice = root.querySelector('[data-slots-notice]');
			if (!notice) {
				notice = el('div', 'harmony-r__slots-notice');
				notice.setAttribute('data-slots-notice', '');
				// inséré juste avant la zone des créneaux
				if (slotsBox && slotsBox.parentNode) {
					slotsBox.parentNode.insertBefore(notice, slotsBox);
				}
			}
			notice.textContent = msg;
			notice.hidden = false;
		}
		function clearSlotsNotice() {
			var notice = root.querySelector('[data-slots-notice]');
			if (notice) { notice.hidden = true; notice.textContent = ''; }
		}

		// Effacer l'erreur d'un champ dès que l'utilisateur le corrige
		root.addEventListener('input', function (e) {
			if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-required')) {
				clearFieldError(e.target);
			}
		});

		// D2 — "formulaire commencé" : au premier focus/saisie dans un champ du formulaire de réservation
		var _formStarted = false;
		root.addEventListener('focusin', function (e) {
			if (_formStarted) return;
			if (e.target && e.target.closest && e.target.closest('[data-form]') && e.target.matches('[data-f]')) {
				_formStarted = true;
				trackEvent('form_commence', { ville: state.selected ? state.selected.ville : '' });
			}
		});

		function submitReservation() {
			var f = readFields('data-f');
			if (!state.selected || !state.slotDate || !state.slot) return;
			if (!validateForm(formBox)) return;
			var data = {
				id_creneau: state.slotDate.id_creneau, ville: state.selected.ville,
				date: state.slotDate.date, heure: state.slot.heure, testeur: state.slotDate.agent,
				prenom: f.prenom, nom: f.nom, email: f.email, telephone: f.telephone, message: f.message
			};

			clearFormError();
			setBtnLoading(submitBtn, true);
			fetch(ENDPOINTS.reservation, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			}).then(function (r) {
				if (r.status === 409) {
					return r.json().then(function (j) { throw { collision: true, body: j }; });
				}
				if (!r.ok) { throw { collision: false }; }
				return r.json();
			}).then(function () {
				// D2 Matomo + D1 Meta : conversion réservation
				trackEvent('reservation_envoyee', { ville: data.ville });
				metaEvent('Schedule', { content_name: 'Démo Harmony', content_category: data.ville });
				showState('✓', txt('successTitle', 'Demande enregistrée'),
					txt('successText', 'Nous revenons vers vous très vite pour confirmer votre créneau.'));
			}).catch(function (err) {
				setBtnLoading(submitBtn, false);
				if (err && err.collision) {
					// A3 : créneau pris entre-temps — message clair au-dessus des créneaux, saisie CONSERVÉE
					var msg = (err.body && err.body.message) ||
						'Ce créneau vient d’être réservé. Vos informations sont conservées — choisissez simplement un autre horaire ci-dessus.';
					trackEvent('creneau_indispo', { ville: data.ville });
					state.slot = null; state.slotDate = null;
					var villeNom = data.ville;
					var dept = state.selected ? state.selected.dept : null;
					loadCreneaux();
					setTimeout(function () {
						var maj = state.villes.filter(function (v) {
							return v.ville === villeNom && String(v.dept) === String(dept);
						})[0];
						if (maj) { selectCity(maj, { silent: true }); } else { resetSelection(); }
						// Message affiché AU-DESSUS des créneaux (hors formulaire, donc persistant)
						showSlotsNotice(msg);
						if (slotsBox && slotsBox.scrollIntoView) slotsBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}, 400);
				} else {
					showFormError('Une erreur est survenue. Merci de réessayer dans un instant.');
				}
			});
		}

		function submitProposition() {
			var f = readFields('data-pf');
			if (!validateForm(proposeForm)) return;
			setBtnLoading(proposeSubmit, true);
			fetch(ENDPOINTS.proposition, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(f)
			}).then(function (r) {
				if (!r.ok) throw new Error('http ' + r.status);
				return r.json();
			}).then(function () {
				showState('📍', txt('proposeSuccessTitle', 'Proposition envoyée'),
					txt('proposeSuccessText', 'Merci ! Nous vous préviendrons dès qu’une démonstration ouvre près de chez vous.'));
			}).catch(function (err) {
				setBtnLoading(proposeSubmit, false);
				alert('Une erreur est survenue. Merci de réessayer dans un instant.');
			});
		}

		/* ---- État de chargement d'un bouton ---- */
		function setBtnLoading(btn, on) {
			if (!btn) return;
			if (on) {
				btn._label = btn.innerHTML;
				btn.disabled = true;
				btn.style.opacity = '0.6';
				btn.innerHTML = '<span>Envoi…</span>';
			} else {
				btn.disabled = false;
				btn.style.opacity = '';
				if (btn._label) btn.innerHTML = btn._label;
			}
		}

		function resetSelection() {
			state.selected = null; state.slotDate = null; state.slot = null;
			selectText.textContent = txt('selectPlaceholder', 'Choisir une ville…');
			slotsBox.innerHTML = '';
			formBox.hidden = true;
		}

		/* ---- Bascule proposer une ville ---- */
		proposeBtn.addEventListener('click', function () {
			setProposeMode(true);
		});
		if (proposeBack) proposeBack.addEventListener('click', function () { setProposeMode(false); });

		function setProposeMode(on) {
			if (mainBlocks) mainBlocks.hidden = on;
			if (proposeForm) proposeForm.hidden = !on;
		}

		/* ---- Écran de succès ---- */
		function showState(icon, title, msg) {
			leftCol.innerHTML = '<div class="harmony-r__state">' +
				'<div class="harmony-r__state-icon" aria-hidden="true">' + icon + '</div>' +
				'<h2 class="harmony-r__state-title h2">' + title + '</h2>' +
				'<p class="harmony-r__state-text">' + msg + '</p></div>';
		}

		/* ---- Chargement créneaux ---- */
		function loadCreneaux() {
			slotsBox.innerHTML = '<div class="harmony-r__skeleton"></div><div class="harmony-r__skeleton" style="width:80%"></div>';
			fetch(ENDPOINTS.creneaux)
				.then(function (r) { return r.json(); })
				.then(function (d) {
					state.villes = (d && d.villes) ? d.villes : [];
					slotsBox.innerHTML = '';
					renderMap();
					if (!state.villes.length) {
						slotsBox.appendChild(el('div', 'harmony-r__place-info', txt('emptyText', 'Aucune démonstration ouverte pour le moment.')));
					} else {
						preselectFromUrl();
					}
				})
				.catch(function (err) {
					console.error('[Harmony] Erreur chargement créneaux :', err);
					slotsBox.innerHTML = '';
					slotsBox.appendChild(el('div', 'harmony-r__place-info', txt('errorText', 'Impossible de charger les créneaux pour le moment.')));
				});
		}

		// Pré-sélection d'une ville via le paramètre d'URL ?ville=Paris
		function preselectFromUrl() {
			var params;
			try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
			var wanted = params.get('ville');
			if (!wanted) return;
			var norm = function (s) {
				return (s || '').toString().trim().toLowerCase()
					.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // enlève les accents
			};
			var target = norm(wanted);
			var match = state.villes.filter(function (v) { return norm(v.ville) === target; })[0];
			if (!match) {
				// tolérance : correspondance partielle (ex. "paris" pour "Paris 15e")
				match = state.villes.filter(function (v) { return norm(v.ville).indexOf(target) !== -1; })[0];
			}
			if (match) selectCity(match, { silent: false });
		}

		// A2 — si ?ville= est présent, poser tout de suite le libellé dans le sélecteur
		// pour qu'aucun flash "Choisir une ville…" n'apparaisse pendant le chargement.
		(function primeCityLabelFromUrl() {
			try {
				var wanted = new URLSearchParams(window.location.search).get('ville');
				if (wanted && selectText) {
					// on affiche le nom brut demandé, joliment capitalisé ; il sera
					// remplacé par le libellé exact (avec dept) dès que les données arrivent
					var pretty = wanted.replace(/\+/g, ' ').trim().replace(/\s+/g, ' ');
					pretty = pretty.charAt(0).toUpperCase() + pretty.slice(1);
					selectText.textContent = pretty;
				}
			} catch (e) {}
		})();

		loadCreneaux();
	}

	function boot() {
		Array.prototype.forEach.call(document.querySelectorAll('.harmony-r[data-section-id]'), initSection);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else { boot(); }
	document.addEventListener('shopify:section:load', function (e) {
		var s = e.target.querySelector('.harmony-r[data-section-id]');
		if (s) initSection(s);
	});
})();